import { useCallback, useEffect, useRef, useState } from 'react';
import { Language } from '.';
import { useLanguage } from './LanguageProvider';
import { IconWorld } from '@tabler/icons-react';

export const LanguageMenu = ({
  color = 'inherit',
}: {
  variant?: string;
  color?: string;
}) => {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => {
    setOpen(prev => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        handleClose();
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open, handleClose]);

  const handleSelectLanguage = useCallback(
    (language: Language) => {
      setLanguage(language);
      localStorage.setItem('selectedLanguage', language);
      handleClose();
    },
    [setLanguage, handleClose]
  );

  return (
    <div
      ref={menuRef}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <button
        type="button"
        onClick={handleClick}
        aria-haspopup="true"
        aria-expanded={open}
        aria-label="Select language"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color,
          fontSize: '14px',
          fontWeight: 500,
          padding: '8px 12px',
          borderRadius: '4px',
        }}
      >
        <IconWorld size={20} />
        {language.toUpperCase()}
      </button>
      {open && (
        <div
          role="menu"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1300,
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow:
              '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
            padding: '4px 0',
            minWidth: '80px',
            marginTop: '2px',
          }}
        >
          <button
            onClick={() => handleSelectLanguage('fr')}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '8px 16px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#333',
            }}
            onMouseEnter={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '')}
          >
            FR
          </button>
          <button
            onClick={() => handleSelectLanguage('en')}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '8px 16px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#333',
            }}
            onMouseEnter={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '')}
          >
            EN
          </button>
        </div>
      )}
    </div>
  );
};
